import { Component, OnInit } from '@angular/core';
import Swal from 'sweetalert2';

import { BillingService } from '@teem/services/billing.service';
import { LoaderService } from '@teem/services/loader.service';
import { messages as i18n } from '@teem/constants/messages';


@Component({
  selector: 'invoice-subscription-history',
  templateUrl: './invoice-subscription-history.component.html',
  styleUrls: ['./invoice-subscription-history.component.scss']
})
export class InvoiceSubscriptionHistoryComponent implements OnInit {

  loadingSubscription: boolean = false;
  subscriptionList: any = [];

  constructor(
    private billingService: BillingService,
    private loaderService: LoaderService
  ) { }

  ngOnInit(): void {
    this.getMySubscription();
  }

  getMySubscription() {
    this.loadingSubscription = true;

    this.billingService.invoiceSubscriptionHistory().subscribe((data: any) => {
      this.subscriptionList = data;
      this.loadingSubscription = false;
    }, err => {
      this.loadingSubscription = false;
      Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
    })
  }

  updateAutoRenew(uuid: string, event: any, item: any) {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.billing.stop_auto_renew,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    }).then(result => {
      if (result.value) {
        let fd: any = {};
        fd.uuid = uuid;
        this.loaderService.startLoading();
        this.billingService.offInvoiceAutoRenew(fd).subscribe((data: any) => {
          this.loaderService.stopLoading();
          event.target.disabled = true;
          this.getMySubscription();
          setTimeout(function () {
            Swal.fire(i18n.done, i18n.billing.auto_renew, 'success');
          }, 0);

        }, err => {
          this.loaderService.stopLoading();
          // event.target.disabled = false;
          event.target.checked = false;
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      } else {
        event.target.checked = false;
        return false;
      }
    });
  }

  cancelAutoRenewOff(uuid: string, event: any, item: any) {
    Swal.fire({
      title: i18n.are_you_sure,
      text: i18n.billing.cancel_auto_renew_off,
      icon: 'info',
      showCloseButton: true,
      showCancelButton: true,
      focusConfirm: false,
      confirmButtonText: i18n.yes,
      cancelButtonText: i18n.no_cancel_it
    }).then(result => {
      if (result.value) {
        this.loaderService.startLoading();
        this.billingService.deleteInvoiceCancelRequest(uuid).subscribe((data: any) => {
          this.loaderService.stopLoading();
          this.getMySubscription();
          setTimeout(function () {
            Swal.fire(i18n.done, i18n.billing.auto_renew_on, 'success');
          }, 0);

        }, err => {
          this.loaderService.stopLoading();
          // event.target.disabled = false;
          event.target.checked = false;
          Swal.fire(i18n.alert.error, i18n.getError(err), 'error');
        })
      } else {
        event.target.checked = true;
        return false;
      }
    });
  }


}

